<template>
  <div class="HomeVideo">
    <div class="hvRight">
      <ul class="hvRlist">
        <li
          class="hvRlistIn"
          v-for="(item, index) in msg.special"
          :key="index"
          @click="toZxDetail(item.id)"
        >
          <van-image
            width="17.5rem"
            height="12.125rem"
            lazy-load
            :src="item.imageurl"
          />
          <div class="hvRname">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeVideo",
  props: ["msg"],
  methods: {
    toZxDetail(id) {
      this.$router.push({ name: "InfDetail", params: { id: id } });
      window.open("https://yooobei.com/#/InfDetail?id=" + id);
      // this.$emit('change2', '1')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.HomeVideo{
    // height 23.75rem
    padding .9375rem 0 0 0
    display flex
}
.hvLname{
    width 40rem
    height 2.5rem
    line-height 2.5rem
    text-align center;
    background rgba(0, 0, 0, 0.4)
    position absolute
    left 0
    bottom .25rem
    color #fff
}

.hvRname{
    position absolute
    left 0
    bottom 1.3125rem
    width  17.5rem;
    height:1.875rem;
    background:rgba(0,0,0,0.3);
    line-height 1.875rem
    text-align center
    color #fff
    cursor pointer
}
.hvRname:hover{
    background  rgba(255, 94, 4, 1)
}
.hvRlist{
    display flex
    justify-content space-between
    flex-wrap wrap
    // height 26.875rem
    cursor pointer
}
.hvRlistIn{
    position relative
    width 17.5rem
    height 13.4375rem
}
.HomeVideo .hvRight{
    margin-left 0
}
</style>
